import {uniqueId} from 'lodash';
import React from 'react';
import {OverlayTrigger, Tooltip as BootstrapTooltip} from 'react-bootstrap';

export const Tooltip = ({
    children,
    tooltip,
    show = true,
    className,
    placement,
}: {
    children?: JSX.Element;
    tooltip: string;
    show?: boolean;
    className?: string;
    placement: 'top' | 'bottom' | 'right' | 'left';
}) => {
    return (
        <OverlayTrigger
            trigger={show ? ['hover', 'click'] : []}
            placement={placement}
            flip
            overlay={
                <BootstrapTooltip
                    id={uniqueId('tooltip')}
                    className={className}
                    style={{...(show ? {} : {display: 'none'})}}>
                    {tooltip}
                </BootstrapTooltip>
            }>
            <div style={{flex: 1}}>{children}</div>
        </OverlayTrigger>
    );
};
